import { render, staticRenderFns } from "./ControlButton.vue?vue&type=template&id=7e0d336f&scoped=true&"
import script from "./ControlButton.vue?vue&type=script&lang=ts&"
export * from "./ControlButton.vue?vue&type=script&lang=ts&"
import style0 from "./ControlButton.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ControlButton.vue?vue&type=style&index=1&id=7e0d336f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e0d336f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/p00353_hh-ballett/client-player/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e0d336f')) {
      api.createRecord('7e0d336f', component.options)
    } else {
      api.reload('7e0d336f', component.options)
    }
    module.hot.accept("./ControlButton.vue?vue&type=template&id=7e0d336f&scoped=true&", function () {
      api.rerender('7e0d336f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ControlButton.vue"
export default component.exports